// src/auth/authConfig.ts
import { AuthProviderProps } from "react-oidc-context";

// Interface pour les options de configuration
interface CognitoAuthConfig {
    authority?: string;
    client_id: string;
    client_secret?: string;
    redirect_uri: string;
    post_logout_redirect_uri?: string;
    response_type: string;
    scope: string;
    automaticSilentRenew?: boolean;
    loadUserInfo?: boolean;
    onSigninCallback?: () => void;
    onSignoutCallback?: () => void;
}

export const cognitoAuthConfig: CognitoAuthConfig = {
    authority: process.env.REACT_APP_AUTHORITY || "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_bRqPkYBv6",
    client_id: process.env.REACT_APP_CLIENT_ID || "1rnbb6r6gp1fo22k51ka5sf2rm",
    client_secret: process.env.REACT_APP_COGNITO_CLIENT_SECRET,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI || "https://connext-afdtech.com/callback",
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "https://connext-afdtech.com/",
    response_type: "code",
    scope: "openid profile email",
    loadUserInfo: true,
    automaticSilentRenew: true,
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
    onSignoutCallback: () => {
        // Redirige après déconnexion
        window.location.href = "/";
    },
};

export default cognitoAuthConfig;